import React from 'react'
import "../css/Support.scss";
import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async'

export default function Support() {
  return (
    <>
      <HelmetProvider>
          <Helmet prioritizeSeoTags>
              <meta charset="utf-8" />
              <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1"
              />
              <meta name="theme-color" content="#005bac" />
              <meta
                  name="keywords"
                  content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン"
              />
              <meta
                  name="description"
                  content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
              />
              <meta
                  property="og:title"
                  content="千葉県千葉市でのホームページ制作ならSmartGenz | トップページ"
              />
              <meta
                  property="og:description"
                  content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
              />
              <meta property="og:type" content="article" />
              <meta property="og:url" content="https://smartgenz.com/" />
              <meta
                  property="og:image"
                  content="%PUBLIC_URL%/smartgenz.jpg"
              />
              <meta
                  property="og:site_name"
                  content="千葉県千葉市でのホームページ制作ならSmartGenz"
              />
              <meta property="og:locale" content="ja_JP" />
              <link
                  rel="apple-touch-icon"
                  href="%PUBLIC_URL%/smartgenz.jpg"
              />
              <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
              <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
              <link rel="canonical" href="https://smartgenz.com/" />
              <title>
                  千葉県千葉市でのホームページ制作ならSmartGenz |
                  トップページ
              </title>
          </Helmet>
      </HelmetProvider>
      <div className='maitenance'>
      <Link to={"/"} className='back_btn'>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </Link>
      <div className="vh">
        <div>
          <div className="wrap">
            <h1>メンテナンスモード</h1>
            <h2>
              <p> ご不便をおかけして申し訳ありません。
                <br />現在、当ウェブサイトは定期メンテナンス中です。
              </p>
            </h2>
              <p>ご理解いただきありがとうございます。</p>
          </div>
        </div>
      </div>
      </div>
    </>
  )
}
